import { checkExportInquiryConstants } from "../constant/checkExportInquiry.constants";

export const initialState = {
    isApprove: "",
    loading: false,
};
const checkExportInquiryReducer = (state = initialState, action) => {
    switch (action.type) {
        case checkExportInquiryConstants.GET_SUCCESS:
            return {
                ...state,
                isApprove: action.checkExport.isApprove,
                loading: false,
            };
        case checkExportInquiryConstants.GET_LOADING:
            return {
                ...state,
                loading: true,
            };
        case checkExportInquiryConstants.GET_DELETE:
            return {
                ...state,
                isApprove: "",
                loading: false,
            };
        default: {
            return state;
        }
    }
};

export default checkExportInquiryReducer;
